"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContentPageList = fetchContentPageList;
exports.fetchPageBySlug = fetchPageBySlug;
exports.fetchMeetingList = fetchMeetingList;
exports.fetchMeetingBySlug = fetchMeetingBySlug;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _q = _interopRequireDefault(require("q"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _settings = require("../utils/settings");

var _constants = require("rich-text-lib/api/constants");

function fetchContentPageList(term, offset, apiClient, scopes) {
  var type = []; // Add page types corresponding to scope access

  if ((0, _settings.hasScope)(_constants.CONTENT_ACCESS_SCOPE, scopes)) {
    if ((0, _settings.hasScope)(_constants.BLOG_ACCESS_SCOPE, scopes)) {
      type.push('BLOG_POST', 'LISTING_PAGE');
    }

    if ((0, _settings.hasScope)(_constants.LANDING_PAGES_ACCESS_SCOPE, scopes)) {
      type.push('LANDING_PAGE');
    }

    if ((0, _settings.hasScope)(_constants.WEBSITE_PAGES_ACCESS_SCOPE, scopes)) {
      type.push('SITE_PAGE');
    }
  }

  if ((0, _settings.hasScope)(_constants.KNOWLEDGE_ACCESS_SCOPE, scopes)) {
    type.push('KNOWLEDGE_ARTICLE');
  }

  return apiClient.get(_constants.ApiMap.PAGES_SEARCH.getUrl(), {
    query: {
      term: term,
      offset: offset,
      type: type
    }
  });
}

function fetchPageBySlug(slug, apiClient, scopes) {
  var pageRequestPromises = [apiClient.get(_constants.ApiMap.PAGES_CONTENT.getUrl(), {
    query: {
      slug: slug,
      property: ['title', 'resolvedDomain']
    }
  })];

  if ((0, _settings.hasScope)(_constants.BLOG_ACCESS_SCOPE, scopes)) {
    pageRequestPromises.push(apiClient.get(_constants.ApiMap.BLOGS.getUrl(), {
      query: {
        property: ['name', 'resolvedDomain', 'id', 'slug']
      }
    }));
  }

  return new _q.default.Promise(function (resolve, reject) {
    _q.default.Promise.all(pageRequestPromises).then(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          pages = _ref2[0],
          blogs = _ref2[1];

      var matchingBlogs = blogs ? blogs.objects.filter(function (blog) {
        return blog.slug === slug;
      }).map(function (blog) {
        return (0, _extends2.default)({}, blog, {
          title: blog.name
        });
      }) : [];
      resolve({
        objects: [].concat((0, _toConsumableArray2.default)(pages.objects), (0, _toConsumableArray2.default)(matchingBlogs))
      });
    }).catch(reject);
  });
}

function fetchMeetingList(apiClient) {
  var meetingsPromise = apiClient.get(_constants.ApiMap.MEETINGS.getUrl());
  var usersPromise = apiClient.get(_constants.ApiMap.USERS.getUrl(), {
    query: {
      hubId: _hubspot.default.get()
    }
  });
  return _q.default.Promise.all([meetingsPromise, usersPromise]);
}

function fetchMeetingBySlug(slug, apiClient) {
  return apiClient.get(_constants.ApiMap.MEETINGS_SEARCH.getUrl(slug));
}